<template>
  <div>
    <div id="search-loading" v-bind:class="[loading ? '' : 'd-none', 'loading']" />
  </div>
</template>

<script>
export default {
  name: 'Loader',
  props: ['loading'],
  data () {
    return {}
  }
}
</script>
<style lang='scss' scoped>
.loading {
  width: 50px;
  height: 50px;
  background-image: url('../assets/loading.gif');
  background-size: 50px 50px;
  margin: 10px auto
}
</style>


// WEBPACK FOOTER //
// src/components/Loader.vue